<template>
  <div class="pd12">
    <SupplierInfoCard @login="handleLogin"/>
    <ShopGoodsList :supplierCompanyId="supplierCompanyId"  @login="handleLogin"/>
  </div>
</template>

<script>
import { generateMiniSchema } from '@/api/distributor';
import ShopGoodsList from "./ShopGoodsList";
import SupplierInfoCard from "./supplierInfoCard";
import { isMobile } from '@/utils';
export default {
  components: {
    ShopGoodsList,
    SupplierInfoCard,
  },
  props: {},
  data() {
    return {
      supplierCompanyId: "",
    };
  },
  computed: {},
  watch: {
    $route: {
      handler(val) {
        console.log('val.name======>',val.name);
        if (val.name == "un_distributeShop") {
          if (val.query.supplierId) {
            this.supplierCompanyId = val.query.supplierId;
          }
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.judgeMobile();
  },
  methods: {
    handleLogin() {
      this.$emit('login')
    },
    async judgeMobile() {
      let res = null;
      const { supplierId } = this.$route.query;
      if (!supplierId) {
        return;
      }
      const mobile = isMobile();
      console.log('是否移动端？', mobile);
      if(isMobile()) {
        this.$router.push({
          path: '/unlogin/wxMiniRedirect',
          query: {
            path: '/supplier/list/index',
            query: `supplierCompanyId=${supplierId}&fromLoginIdentity=1`,
          }
        })
      }
    }
  },
};
</script>

<style scoped>
.supplier-info-box {
  padding: 16px 16px 0 16px;
}
</style>
